import type { GetIndicatorTitlesByParentIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetIndicatorTitlesByParentIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetIndicatorTitlesByParentIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetIndicatorTitlesByParentIdArgs = {
  parentId: string;
};

export const useGetIndicatorTitlesByParentId = createQueryHook<
  UseGetIndicatorTitlesByParentIdArgs,
  GetIndicatorTitlesByParentIdResponseRow[],
  GetIndicatorTitlesByParentIdQuery
>({
  trpcQueryOptions: (trpc, { parentId }) =>
    trpc.frontend.indicator.indicatorTitlesByParentId.queryOptions({
      parentId,
    }),
  mapTrpcDataToGraphQL: (data) => ({ indicator: data }),
  graphqlDocument: GetIndicatorTitlesByParentIdDocument,
  graphqlVariables: ({ parentId }) => ({ parentId }),
});
